module.exports = __webpack_public_path__ + "assets/img/index-project2-6.b3695060.jpg";